import { ILaunchArguments } from './launchArguments';

class EvolunoLaunchArguments implements ILaunchArguments {
  getLaunchArguments = () => {
    return {};
  };
  getTestToken = () => {
    return undefined;
  };
}
export default new EvolunoLaunchArguments();
